import React, { useEffect, useState } from 'react';
import { IProcessingMergeBody } from './processingMergeBody.models';
import ProcessingMergeSelectDataset from './processingMergeSelectDataset/processingMergeSelectDataset.component';
import ProcessingMergeUploadDataset from './processingMergeUploadDataset/processingMergeUploadDataset.component';
import ProcessingMergeJoin from './processingMergeJoin/processingMergeJoin.component';

const ProcessingMergeBody: React.FC<IProcessingMergeBody> = ({
  isDuplicateChecked,
  setIsDuplicateChecked,
  onClose,
  data,
  setData,
  selectedMergeJoinOption,
  setSelectedMergeJoinOption,
  extensionError,
  setExtensionError,
  processingMergeJoinBlocks,
  setProcessingMergeJoinBlocks,
  summaryData,
  processingMergeInputData,
  setProcessingMergeInputData,
  processingMergeActiveStep,
  setProcessingMergeActiveStep,
  processingMergeUploadStatus,
  setProcessingMergeUploadStatus,
  processingMergeUploadProgress,
  setProcessingMergeUploadProgress,
  processingMergeUploadSucceeded,
  setProcessingMergeUploadSucceeded,
  processingMergeNewFileNameValue,
  setProcessingMergeNewFileNameValue
}) => {
  const [statusId, setStatusId] = useState<string>('');
  const [isStop, setIsStop] = useState<boolean>(false);
  const [stopped, setStopped] = useState<boolean>(false);
  const stoppedRef = React.useRef(stopped);

  return (
    <>
      {processingMergeActiveStep === 1 && (
        <ProcessingMergeSelectDataset
          processingMergeInputData={processingMergeInputData}
          setProcessingMergeInputData={setProcessingMergeInputData}
          summaryData={summaryData}
          processingMergeActiveStep={processingMergeActiveStep}
          setProcessingMergeActiveStep={setProcessingMergeActiveStep}
          processingMergeUploadStatus={processingMergeUploadStatus}
          setProcessingMergeUploadStatus={setProcessingMergeUploadStatus}
          processingMergeUploadProgress={processingMergeUploadProgress}
          setProcessingMergeUploadProgress={setProcessingMergeUploadProgress}
          processingMergeUploadSucceeded={processingMergeUploadSucceeded}
          setProcessingMergeUploadSucceeded={setProcessingMergeUploadSucceeded}
          setDatasetOrUpload=""
          setStopped={setStopped}
          isStop={isStop}
          setIsStop={setIsStop}
          statusId={statusId}
          setStatusId={setStatusId}
          stoppedRef={stoppedRef}
          stopped={stopped}
        />
      )}
      {processingMergeActiveStep === 2 && (
        <ProcessingMergeUploadDataset
          summaryData={summaryData}
          processingMergeInputData={processingMergeInputData}
          setProcessingMergeActiveStep={setProcessingMergeActiveStep}
          processingMergeUploadStatus={processingMergeUploadStatus}
          setProcessingMergeUploadStatus={setProcessingMergeUploadStatus}
          processingMergeUploadProgress={processingMergeUploadProgress}
          setProcessingMergeUploadProgress={setProcessingMergeUploadProgress}
          processingMergeUploadSucceeded={processingMergeUploadSucceeded}
          setProcessingMergeUploadSucceeded={setProcessingMergeUploadSucceeded}
          setStopped={setStopped}
          isStop={isStop}
          setIsStop={setIsStop}
          statusId={statusId}
          setStatusId={setStatusId}
        />
      )}
      {processingMergeActiveStep === 3 && (
        <ProcessingMergeJoin
          isDuplicateChecked={isDuplicateChecked}
          setIsDuplicateChecked={setIsDuplicateChecked}
          onClose={onClose}
          data={data}
          setData={setData}
          selectedMergeJoinOption={selectedMergeJoinOption}
          setSelectedMergeJoinOption={setSelectedMergeJoinOption}
          extensionError={extensionError}
          setExtensionError={setExtensionError}
          processingMergeJoinBlocks={processingMergeJoinBlocks}
          setProcessingMergeJoinBlocks={setProcessingMergeJoinBlocks}
          summaryData={summaryData}
          processingMergeInputData={processingMergeInputData}
          processingMergeNewFileNameValue={processingMergeNewFileNameValue}
          setProcessingMergeNewFileNameValue={setProcessingMergeNewFileNameValue}
        />
      )}
    </>
  );
};

export default ProcessingMergeBody;
